import { render, staticRenderFns } from "./landQuickApp.vue?vue&type=template&id=4236d887&scoped=true"
import script from "./landQuickApp.vue?vue&type=script&lang=js"
export * from "./landQuickApp.vue?vue&type=script&lang=js"
import style0 from "./landQuickApp.vue?vue&type=style&index=0&id=4236d887&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4236d887",
  null
  
)

export default component.exports